"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateLogData = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const json_stringify_safe_1 = __importDefault(require("json-stringify-safe"));
const tools_1 = require("../tools");
const types_1 = require("../types");
const generateLogData = (log = {}) => {
    const firstName = en_1.faker.person.firstName();
    return {
        id: log.id || (0, tools_1.IDSource)(),
        timestamp: log.timestamp || new Date(),
        bi_timestamp: log.timestamp || new Date(),
        action_code: log.action_code || en_1.faker.helpers.arrayElement(Object.values(types_1.ACTION_CODE)),
        detailed_action_code: log.action_code ||
            en_1.faker.helpers.arrayElement(Object.values(types_1.DETAILED_ACTION_CODE)),
        user_type: log.user_type || en_1.faker.helpers.arrayElement(Object.values(types_1.USER_TYPE)),
        status: log.status || "SUCC",
        user_id: log.user_id || (0, tools_1.IDSource)(),
        user_name: log.user_name || en_1.faker.internet.userName(firstName),
        user_phone: log.user_phone || en_1.faker.phone.number(),
        user_email: log.user_email || en_1.faker.internet.email(firstName),
        data: (0, json_stringify_safe_1.default)(log.data) || "{}",
    };
};
exports.generateLogData = generateLogData;
